import NextSteps from 'components/Footer/NextSteps';
import { Img } from 'components/shared';
import * as React from 'react';
export default {
  NextSteps,
  Img,
  React
};